module.exports = __webpack_public_path__ + "img/OnlineCoursesBackgroundBanner.f436e5c4.png";